import React from 'react';
import Heading from '../Heading';
import Text from '../Text';
import Wrapper from '../Wrapper';
import AIAdaptabilityTable from '../AIAdaptabilityTable';
import ProjectsYoullBuild from './ProjectsYoullBuild';
import LeadGenerationOpenForm from '@components/LeadGenerationForm/LeadGenerationOpenForm';
import CourseAccordion from './CourseAccordion';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { navigate } from 'gatsby';

const heroData = {
  entrepreneurs: {
    title: 'Founders/Entrepreneurs',
    description:
      'AI-powered entrepreneurship: Build, validate, and scale your startup using intelligent automation. Launch faster, validate smarter, and grow efficiently with AI as your co-founder.',
  },
  'product-marketing-management': {
    title: 'Product/Product Marketing Management',
    description:
      'AI-accelerated product development: Transform product strategy, research, and execution using intelligent automation. Build better products faster with AI-powered insights and rapid prototyping.',
  },
  marketing: {
    title: 'Marketing',
    description:
      'AI-native marketing: Create compelling content, understand audiences deeply, and optimize campaigns using intelligent automation. Scale your marketing impact with AI-powered creativity and data-driven insights.',
  },
  consulting: {
    title: 'Consulting',
    description:
      'AI-enhanced consulting: Deliver superior client outcomes using intelligent research, analysis, and strategic frameworks. Scale your expertise and provide deeper insights with AI-powered consulting tools.',
  },
  'design-ui-ux': {
    title: 'Design/UI/UX',
    description:
      'AI-powered design: Accelerate ideation, enhance user research, and streamline design workflows using intelligent automation. Create better user experiences faster while maintaining design quality and human creativity.',
  },
  operations: {
    title: 'Operations',
    description:
      'AI-driven operations: Optimize business processes, enhance efficiency, and improve decision-making using intelligent automation. Scale operations effectively with AI-powered insights and predictive analytics.',
  },
};

const GenAIProgramPage = ({ slug }) => {
  const companies = [
    { name: 'Microsoft', logo: '/images/GenAI/Microsoft.png' },
    { name: 'Amazon', logo: '/images/GenAI/Amazon.png' },
    { name: 'Grab', logo: '/images/GenAI/Grab.png' },
    { name: 'Salesforce', logo: '/images/GenAI/Salesforce.png' },
    { name: 'Oracle', logo: '/images/GenAI/Oracle.png' },
    { name: 'Groww', logo: '/images/GenAI/Groww.png' },
  ];

  const data = heroData?.[slug];

  const ValuedCompanies = () => {
    return (
      <div className="max-w-[800px] rounded-xl bg-[#E7F7F6] px-6 py-8 text-center shadow-md">
        <Heading>Companies That Value This Skill</Heading>
        <div className="align-center grid max-w-[560px] grid-cols-2 justify-center gap-4 md:grid-cols-3 md:gap-6">
          {companies.map((company, idx) => (
            <img
              key={idx}
              src={company.logo}
              alt={company.name}
              className="w-[120px] object-contain md:w-[175px]"
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="mx-auto max-w-[1200px]">
      <button
        onClick={() => navigate('/gen-ai-certificate-program/')}
        className="hidden items-center space-x-2 text-black transition hover:opacity-80 md:flex"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>
        <span className="font-manrope font-extrabold capitalize tracking-normal md:text-[24px] md:leading-[54px]">
          AI Upskill
        </span>
      </button>
      <div className="mx-4 flex flex-col gap-6 md:flex-row">
        {/* <Wrapper> */}
        <div>
          <Heading>{data.title}</Heading>
          <Text>{data.description}</Text>
          <div className="my-6 hidden md:block">
            <CourseAccordion slug={slug} />
            <ValuedCompanies />
          </div>
        </div>
        {/* </Wrapper> */}
        <div className="top-24 z-[1000] md:h-[450px] lg:sticky">
          <LeadGenerationOpenForm
            isOpenForm={true}
            onSubmitPageTwo={() => {}}
            disableDemoSlots={true}
            wrapperClassName={'flex justify-center'}
          />
        </div>
      </div>
      <div>
        <Wrapper className="block md:hidden">
          <CourseAccordion slug={slug} />
        </Wrapper>
        <Wrapper>
          <Heading>Key Highlights</Heading>
          <AIAdaptabilityTable slug={slug} />
        </Wrapper>

        <Wrapper>
          <ProjectsYoullBuild slug={slug} />
        </Wrapper>
      </div>
    </div>
  );
};

export default GenAIProgramPage;
